import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const HondaFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Honda"
      slug="/lenders/mis-sold-honda-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default HondaFinancePage
